<template>
  <!-- Our Blogs -->
  <section class="blogs-nine-section section">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="section-heading section-heading-nine aos" data-aos="fade-up">											
            <span class="title-badge">Latest Articles</span>
            <h2>Our <span>Blogs</span></h2>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel blogs-nine-slider">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in indexnineblog" :key="item.id">
                <div class="blog blog-new flex-fill">
                  <div class="blog-image">
                    <router-link to="/blogs/blog-details"><img class="img-fluid" :src="require(`@/assets/img/blog/${item.image}`)" alt="Post Image"></router-link>
                    <div class="date">
                      {{item.date}}<span>Dec</span>
                    </div>
                  </div>
                  <div class="blog-content text-start">
                    <div class="blog-user-info d-flex align-items-center justify-content-between">
                      <div class="blog-user d-flex align-items-center">
                        <img :src="require(`@/assets/img/profiles/${item.avatar}`)" alt="User">
                        <span>{{item.name}}</span>
                      </div>
                      <h6><i class="feather-tag me-1"></i>Services</h6>
                    </div>
                    <h3 class="blog-title">
                      <router-link to="/blogs/blog-details">{{item.title}}</router-link>
                    </h3>
                    <p>{{item.content}}</p>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <Pagination />
              </template>
            </Carousel>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-sm-6">
            <div class="slidernav2 dots-bottom owl-dots text-center text-md-start"></div>
          </div>
          <div class="col-sm-6">
            <div class="btn-service-nine text-center text-md-end aos" data-aos="fade-up">
              <router-link to="/blogs/blog-list" class="btn btn-primary btn-view">View all  Blogs</router-link>
            </div>						
          </div>
        </div>
      </div>
      <div class="free-service-all">
					<div class="row align-items-center aos" data-aos="fade-up">
						<div class="col-lg-6 col-12">
							<div class="free-service-nine">
								<div class="free-service-img-one">
									<img src="@/assets/img/service-img-9.jpg" alt="image">
									<img src="@/assets/img/icons/offer-icon.svg" alt="image" class="icon-01">
								</div>
								<div class="free-service-img-two">
									<img src="@/assets/img/service-img-10.jpg" alt="image">
								</div>
								<img src="@/assets/img/icons/offer-icon-01.png" alt="image" class="offer-icon">
								<img src="@/assets/img/icons/choose-icon-01.svg" alt="image" class="choose-icon">
							</div>
						</div>
						<div class="col-lg-6 col-12">
							<div class="free-service-bottom-content">
								<div class="section-heading section-heading-nine free-heading-nine aos"
									data-aos="fade-up">
									<h2 class="mb-2">Get Offer on Premium <span>Services</span></h2>
								</div>
								<p>Whether you're looking to our app brings everything you need right to your fingertips.</p>
								<router-link to="/booking/booking" class="btn btn-primary">Book an Appointment</router-link>
							</div>
						</div>
					</div>
				</div>
    </div>
  </section>
  <!-- /Our Blogs -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexnineblog from "@/assets/json/indexnineblog.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexnineblog: indexnineblog,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>
